<template>
    <div>
        <div class="tabs">
            <ul>
                <router-link tag="li" :to="{ name: 'system-mbk-locked-deposites' }" active-class="is-active">
                    <a>Locked deposites</a>
                </router-link>
            </ul>
        </div>

        <div>
            <router-view />
        </div>
    </div>
</template>
<script>
export default {
    name: 'system-mbk'
};
</script>
<style>
</style>



// WEBPACK FOOTER //
// front/src/components/mbk/index.vue